import { render, staticRenderFns } from "./ConfirmSave.vue?vue&type=template&id=2cfb1b42&scoped=true&"
import script from "./ConfirmSave.vue?vue&type=script&lang=js&"
export * from "./ConfirmSave.vue?vue&type=script&lang=js&"
import style0 from "./ConfirmSave.vue?vue&type=style&index=0&id=2cfb1b42&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2cfb1b42",
  null
  
)

export default component.exports